import { getCaseGroundLevel } from '../../../../../projection/cases/queries/levels/getCaseGroundLevel';
import { CaseProjection } from '../../../../../projection/cases/CaseProjection';

export const getCaseDataGroundLevelForcedSurface = (caseProjection: CaseProjection) =>
  getCaseGroundLevel(caseProjection)?.realBuiltSurface;
